<div class="d-flex justify-content-between mat-elevation-z4 p-2">
    <h4>
        Application list
    </h4>
    <button class="btn btn-outline-primary" routerLink="/admin/apps/add">
        Add application
        <i class="bi bi-plus-lg"></i>
    </button>
</div>

<hr>


<table class="table table-hover">
    <thead>
        <tr>
            <th>Id</th>
            <th>Name</th>
            <th>Url</th>
            <th>Environment</th>
            <th>Active</th>
            <th></th>
        </tr>
    </thead>
    <tbody class="align-middle">
        <tr *ngFor="let app of Data">
            <td>
                {{ app.IdApplication }}
            </td>
            <td>
                {{ app.ApplicationName }}
            </td>
            <td>
                <a [href]="app.Url" target="_blank" rel="noopener noreferrer" class="link w-100">
                    {{ app.Url }}
                </a>
            </td>
            <td>
                <span class="badge bg-success" *ngIf="app.Production;else testApplicationTemplate">production</span>
            </td>
            <td>
                <span class="badge bg-success" *ngIf="app.Active;else inactiveApplicationTemplate">active</span>
            </td>
            <td>
                <button class="btn btn-sm btn-outline-primary" [routerLink]="'detail/' + app.Id">
                    <i class="bi bi-search"></i>
                </button>
            </td>
        </tr>
    </tbody>
</table>

<ng-template #testApplicationTemplate>
    <span class="badge bg-danger">test</span>
</ng-template>

<ng-template #inactiveApplicationTemplate>
    <span class="badge bg-danger">disabled</span>
</ng-template>

<app-mercedes-loader *ngIf="Loading"></app-mercedes-loader>